import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { WidgetTheme } from '../../WidgetTheme'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetProps } from '../../widget.types'
import * as Styles from './styles'

export const Skeleton = ({ service, tipOrder }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })

  return (
    <WidgetTheme theme={theme.loading} tipOrder={tipOrder}>
      <Styles.Container data-testid="dashboard-widget-skeleton">
        <Styles.Box>
          <Styles.InfoContainer>
            <Styles.HeaderContainer>
              {!isPhone && <Styles.Skeleton width={265} height={24} />}
              <Styles.Skeleton width={165} height={24} />
            </Styles.HeaderContainer>
            <Styles.SubHeaderContainer>
              <Styles.Skeleton width={isPhone ? undefined : 265} height={12} />
              <Styles.Skeleton width={isPhone ? undefined : 265} height={12} />
              <Styles.Skeleton width={165} height={12} />
            </Styles.SubHeaderContainer>
            <Styles.ActionsSkeleton>
              <Styles.Skeleton width={isPhone ? undefined : 300} height={isPhone ? 44 : 48} />
            </Styles.ActionsSkeleton>
          </Styles.InfoContainer>
        </Styles.Box>
        <Styles.Box />
      </Styles.Container>
    </WidgetTheme>
  )
}
